let d365maCompanies = []
export function init_coverage($sectionObj) {
    /**
     * the ul-li element is appended as it creates a custom dropdown to the search field which fetches data from an API endpoint and adds a list to the UL
     */
    let $coverageWrapper = $sectionObj
    let $org = $coverageWrapper.find('.organization')
    let $orgName = $coverageWrapper.find('.org-name')
    let $companyid = $coverageWrapper.find('.company-id')
    let $addressid = $coverageWrapper.find('.address-id')
    let $companySuggestion = $coverageWrapper.find('#companies-suggestions')
    let $coverageMenu = $('.business-search-form');

    $org.attr('autocomplete', 'off')
    $org.attr('type', 'search')
    $org.blur(onCompanyFieldBlur)
    $org.focus(onCompanyFieldFocus)
    $org.keydown(onCompanyFieldKeyDown)
    $org.on('input', onCompanyFieldInput)

    function onCompanyFieldInput() {

        $companySuggestion.children().remove()
        const company = $coverageWrapper.find('.organization').val()
        if (company === '') return

        let url = '/wp-json/api/v1/business_search?query='+company
        
        $.ajax({
            type: 'post',
            url: '/wp-json/api/v1/business_search?query='+company,
            success: function (data) {
                $companySuggestion.empty()
                let i = 0
                let elements = []
                let redirectUrl = $companySuggestion.attr('data-redirect-url')
                d365maCompanies = data
                if(data) {
                    data.forEach(o => {
                        let orgNo = $('<span>').text(`(${o.orgNr})`)
                        let divElement = $('<div>')
                            .addClass(`option flag-${o.countryCode}`)
                            .append(`${o.businessName} `, orgNo)
                        let liElement = $('<li>')
                            .attr('id', `option-${i}`)
                            .addClass('dropdown-option')
                            .mousedown(onCompanyOptionMouseDown)
                            .hover(onCompanyOptionHover)
                            .append(divElement)
                        $companySuggestion.append(liElement)
                        i++
                    })
                }
                $companySuggestion
                    .children('.dropdown-option')
                    .first()
                    .addClass('dropdown-option--highlight')
            }
        })
    }

    function onCompanyOptionMouseDown(e) {
        let index = parseInt(e.delegateTarget.id.replace('option-', ''))
        let companyInfo = d365maCompanies[index]
        let searchFormObject = $coverageWrapper.find('.coverage-search-form') 
        let actionUrl = searchFormObject.attr('action')
        $org.val(companyInfo.orgNr)
        if($companyid) {
            $companyid.val(companyInfo.companyId)
        }
        if($addressid) {
            $addressid.val(companyInfo.addressId)
        }
        $orgName.val(companyInfo.businessName)
        if(actionUrl != '') {
            searchFormObject.submit()
        }
    }

    /**
     *
     * @param {*} e event attributes object
     * to highlight the selection this function is being used
     */
    function onCompanyOptionHover(e) {
        $companySuggestion
            .children('.dropdown-option--highlight')
            .first()
            .removeClass('dropdown-option--highlight')
        $(e.delegateTarget).addClass('dropdown-option--highlight')
    }

    /**
     * once the user moved focus from this field without selecting a company, it just clears the list and hide it
     */
    function onCompanyFieldBlur() {
        $companySuggestion
            .css('display', 'none')
            .css('visibility', 'hidden')
            .removeClass('dropdown-menu')
    }

    /**
     * on field focus it adds some custom class to the comapany dropdown
     */
    function onCompanyFieldFocus() {
        $companySuggestion
            .removeAttr('style')
            .addClass('dropdown-menu')
    }

    /**
     *
     * this is same like mouse hover just listens to the arrow keys to highlight the list item 
     * and scrolls if list is big and does not fit the field of view of dropdown
     */
    function onCompanyFieldKeyDown() {
        switch (event.which || event.keyCode) {
            case 40: // Down
                if (
                    $companySuggestion.children('.dropdown-option--highlight')[0] !==
                    $companySuggestion.children('li').last()[0]
                ) {
                    $companySuggestion
                        .children('.dropdown-option--highlight')
                        .first()
                        .removeClass('dropdown-option--highlight')
                        .next()
                        .addClass('dropdown-option--highlight')
                    $companySuggestion.scrollTop(
                        document.getElementById(
                            document.querySelector('.dropdown-option--highlight').id
                        ).offsetTop - 10
                    )
                }
                break

            case 38: // Up
                if (
                    $companySuggestion.children('.dropdown-option--highlight')[0] !==
                    $companySuggestion.children('li').first()[0]
                ) {
                    $companySuggestion
                        .children('.dropdown-option--highlight')
                        .first()
                        .removeClass('dropdown-option--highlight')
                        .prev()
                        .addClass('dropdown-option--highlight')

                    $companySuggestion.scrollTop(
                        document.getElementById(
                            document.querySelector('.dropdown-option--highlight').id
                        ).offsetTop - 10
                    )
                }
                break

            case 13: // Enter
                let selected = $companySuggestion
                    .children('.dropdown-option--highlight')
                    .first()
                if (selected.length > 0) {
                    onCompanyOptionMouseDown({ delegateTarget: selected[0] })
                }
                break

            case 27: // Esc
                $('#organization').blur()
                break

            default:
                return
        }

        event.preventDefault()
    }
}
